(function () {
    var section = document.querySelector('section.related-groups');
    if (!section) return;

    var filterName  = section.dataset.filterName;
    var queryKey    = section.dataset.queryKey;
    var eventsUrl   = section.dataset.eventsUrl;
    var eventsDataId = section.dataset.eventsDataId;
    var fallbackUrl = section.dataset.fallbackUrl;

    function getCheckedMembers() {
        return Array.from(section.querySelectorAll('input[name="' + filterName + '"]:checked'))
            .map(function (cb) { return cb.value; });
    }

    function fetchPage(page) {
        var members = getCheckedMembers();
        var params = new URLSearchParams({ page: page });
        params.set(queryKey, members.join(','));
        var url = eventsUrl + '?' + params.toString();

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) {
                if (!r.ok) throw new Error('Network response not ok');
                return r.text();
            })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                // Update window.upcomingEvents for modal lookups
                var dataEl = doc.getElementById(eventsDataId);
                if (dataEl && dataEl.dataset.events) {
                    try { window.upcomingEvents = JSON.parse(dataEl.dataset.events); } catch (_) {}
                }

                // Replace event list section in place
                var existingList = section.querySelector('.event-list-section');
                var newList = doc.querySelector('.event-list-section');
                if (newList) {
                    if (existingList) {
                        existingList.replaceWith(newList);
                    } else {
                        var footer = section.querySelector('.related-groups-footer');
                        if (footer) {
                            footer.before(newList);
                        } else {
                            section.appendChild(newList);
                        }
                    }
                } else if (existingList) {
                    existingList.remove();
                }

                // Re-attach modal click handlers to new event items
                document.dispatchEvent(new CustomEvent('calendarListUpdated'));

                // Smooth-scroll section top into view
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            })
            .catch(function () {
                window.location.href = fallbackUrl + '?page=' + page;
            });
    }

    // Pagination link clicks
    section.addEventListener('click', function (e) {
        var link = e.target.closest('a.pagination-link, a.pagination-number');
        if (!link) return;
        e.preventDefault();
        var page = new URLSearchParams(link.getAttribute('href')).get('page') || '1';
        fetchPage(parseInt(page, 10));
    });

    // Filter checkbox changes — reset to page 1
    section.addEventListener('change', function (e) {
        if (!e.target.matches('input[name="' + filterName + '"]')) return;
        fetchPage(1);
    });
}());
